import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: 'white'
  },
  timeline: {
    height: '20%',
    minHeight: 100,
    margin: '15px 0'
  },
  contentArea: {
    flexGrow: 100,
    padding: '0 20px'
  },
  actionArea: {
    height: '15%',
    minHeight: 60,
    margin: '15px 0',
    padding: '0 20px'
  },
  button: {
    fontSize: 15
  },
  justifyCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

export default useStyles;
